import { Attributes, ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";
import { TextConstants } from "../../../../Common/TextConstants";

@NeoModel
export default class StaticExportColumnSpecLookup extends ModelBase {
    
    public staticExportColumnSpecId: number = 0;

    public staticExportFileSpecId: number = 0;

    @Rules.StringLength(100)
    @Rules.Required()
    public fieldName: string = "";

    @Rules.StringLength(250)
    @Rules.Required()
    public description: string = "";

    public reportName: string = "";

    @Rules.StringLength(50)
    @Rules.Required()
    public dataType: string = "";

    @Rules.StringLength(50)
    public displayFormat: string = "";

    @Rules.Required()
    @Attributes.Integer()
    public columnNumber: number | null = null;

    public reportSpecId: number = 0;

    public fileSpecPropertiesConcatenated: string = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(d => d.dataType === "Datetime" && (d.displayFormat === undefined || d.displayFormat === ""), TextConstants.Validation.MissingDateFormat);
    }
}